/* eslint-disable */
export default {
  to: 'To:',
  transferTo: 'Transfer to',
  blindTransfer: 'Transfer',
  warmTransfer: 'Ask first',
  enterNameOrNumber: 'Enter number',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"transferTo"@#@ @source: @#@"Transfer to"@#@
// @key: @#@"blindTransfer"@#@ @source: @#@"Transfer"@#@
// @key: @#@"warmTransfer"@#@ @source: @#@"Ask first"@#@
// @key: @#@"enterNameOrNumber"@#@ @source: @#@"Enter Number"@#@
